import { css } from 'styled-components';
import colors from '../../constants/js/colors';
import colorsRedesign from '../../constants/js/colors-redesign';
export const buildSkin = options => options && css(["", ";", ";", ";&:hover{", ";", ";}&:active{", ";", ";", ";}"], options.color && `color: ${options.color}`, options.bgColor && `background-color: ${options.bgColor}`, options.borderColor && `border-color: ${options.borderColor}`, options.borderColorHover && `border-color: ${options.borderColorHover}`, options.bgColorHover && `background-color: ${options.bgColorHover}`, options.bgColorActive && `background-color: ${options.bgColorActive}`, options.colorActive && `color: ${options.colorActive}`, options.borderColorActive && `border-color: ${options.borderColorActive}`);
export const defaultThemeButton = {
  Button: {
    skin: {
      blue: {
        color: colors.majorWhite,
        bgColor: colorsRedesign.blue600,
        bgColorHover: colorsRedesign.blue500,
        bgColorActive: colorsRedesign.blue500
      },
      orange: {
        color: colors.majorWhite,
        bgColor: colors.majorOrange,
        bgColorHover: colors.majorAmber700,
        bgColorActive: colors.minorOrange
      },
      green: {
        color: colors.majorWhite,
        bgColor: colors.majorGreen,
        bgColorHover: colors.minorGreen,
        bgColorActive: colors.minorGreen600
      },
      red: {
        color: colors.majorWhite,
        bgColor: colors.majorRed,
        bgColorHover: colors.majorRed500,
        bgColorActive: colors.majorRed800
      },
      'transparent-light': {
        color: colors.minorDarkBlue,
        borderColor: colors.minorGrayLighten,
        borderColorHover: colors.majorGray,
        borderColorActive: colors.silverStrong,
        bgColor: 'transparent',
        bgColorActive: 'transparent',
        colorActive: colors.minorDarkBlue
      },
      white: {
        color: colors.minorDarkBlue,
        borderColor: colors.minorGrayLighten,
        borderColorHover: colors.majorGray,
        borderColorActive: colors.silverStrong,
        bgColor: colors.majorWhite,
        bgColorActive: colors.majorWhite,
        colorActive: colors.minorDarkBlue
      },
      gray: {
        color: colors.majorBlack,
        bgColor: colors.majorWhite,
        bgColorHover: colors.blueGray40,
        bgColorActive: colors.minorGrayLighten2
      },
      'transparent-dark': {
        color: colors.majorWhite,
        borderColor: colors.whiteTrans4,
        borderColorHover: colors.whiteTrans7,
        borderColorActive: colors.majorWhite,
        bgColor: 'transparent',
        bgColorActive: colors.minorBlackLighten2,
        colorActive: colors.majorBlack
      },
      custom: {}
    }
  }
};